var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99938 5.64916C5.98971 5.46531 5.83283 5.32413 5.64899 5.3338C5.46515 5.34348 5.32396 5.50035 5.33364 5.68419L5.66697 12.0175C5.67665 12.2014 5.83352 12.3426 6.01736 12.3329C6.20121 12.3232 6.34239 12.1663 6.33272 11.9825L5.99938 5.64916Z",
    fill: "#006241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6661 5.68419C10.6757 5.50035 10.5345 5.34348 10.3507 5.3338C10.1669 5.32413 10.01 5.46531 10.0003 5.64916L9.66697 11.9825C9.6573 12.1663 9.79848 12.3232 9.98233 12.3329C10.1662 12.3426 10.323 12.2014 10.3327 12.0175L10.6661 5.68419Z",
    fill: "#006241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33318 5.66668C8.33318 5.48258 8.18394 5.33334 7.99985 5.33334C7.81575 5.33334 7.66651 5.48258 7.66651 5.66668V12C7.66651 12.1841 7.81575 12.3333 7.99985 12.3333C8.18394 12.3333 8.33318 12.1841 8.33318 12V5.66668Z",
    fill: "#006241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1665 3.5V2.66667C11.1665 2.02233 10.6442 1.5 9.99984 1.5H5.99984C5.3555 1.5 4.83317 2.02233 4.83317 2.66667V3.5H2.6665C2.39036 3.5 2.1665 3.72386 2.1665 4C2.1665 4.27614 2.39036 4.5 2.6665 4.5H2.86489L3.4192 12.9533C3.48241 13.9172 4.28266 14.6667 5.24861 14.6667H10.7511C11.717 14.6667 12.5173 13.9172 12.5805 12.9533L13.1348 4.5H13.3332C13.6093 4.5 13.8332 4.27614 13.8332 4C13.8332 3.72386 13.6093 3.5 13.3332 3.5H11.1665ZM5.83317 2.66667C5.83317 2.57462 5.90779 2.5 5.99984 2.5H9.99984C10.0919 2.5 10.1665 2.57462 10.1665 2.66667V3.5H5.83317V2.66667ZM4.41706 12.8879L3.86704 4.5H12.1326L11.5826 12.8879C11.5539 13.326 11.1901 13.6667 10.7511 13.6667H5.24861C4.80954 13.6667 4.44579 13.326 4.41706 12.8879Z",
    fill: "#006241"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.46ba8f863451ec18c11388f61542e663.svg";
export { ForwardRef as ReactComponent };